import { render } from "./TransactionDetail.vue?vue&type=template&id=b946dc1e&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"

import "./TransactionDetail.vue?vue&type=style&index=0&id=b946dc1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b946dc1e"]])

export default __exports__